import React, { useState, useEffect } from "react";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { getTenantDetails } from "../constant/Utils";
import { emailRegex } from "../constant/const";
import { COUNTRY_CODES } from "../constant/countryCodes";

const AddContact = (props) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("55");
  const [phone, setPhone] = useState("");  // formatted display: (XX) XXXXX-XXXX
  const [email, setEmail] = useState("");
  const [addYourself, setAddYourself] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isUserExist, setIsUserExist] = useState(false);

  useEffect(() => {
    checkUserExist();
  }, []);

  useEffect(() => {
    const savedUserDetails = JSON.parse(
      localStorage.getItem("UserInformation")
    );
    if (savedUserDetails && addYourself) {
      setName(savedUserDetails.name);
      setCountryCode(savedUserDetails.phone?.slice(0, savedUserDetails.phone.length - 11) || "55");
      // assume savedUserDetails.phone is full digits
      const digits = (savedUserDetails.phone || "").replace(/\D/g, "").slice(-11);
      // format digits as (DD) XXXXX-XXXX
      let formatted = digits;
      if (digits.length > 2) formatted = `(${digits.slice(0,2)}) ${digits.slice(2)}`;
      if (digits.length > 7) formatted = `(${digits.slice(0,2)}) ${digits.slice(2,7)}-${digits.slice(7,11)}`;
      setPhone(formatted);
      setEmail(savedUserDetails.email);
    }
  }, [addYourself]);

  const checkUserExist = async () => {
    try {
      const baseURL = localStorage.getItem("baseUrl");
      const url = `${baseURL}functions/isuserincontactbook`;
      const token = {
        "X-Parse-Session-Token": localStorage.getItem("accesstoken")
      };
      const headers = {
        "Content-Type": "application/json",
        "X-Parse-Application-Id": localStorage.getItem("parseAppId"),
        ...token
      };
      const axiosRes = await axios.post(url, {}, { headers });
      const contactRes = axiosRes?.data?.result || {};
      if (!contactRes?.objectId) {
        setIsUserExist(true);
      }
    } catch (err) {
      console.log("err ", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // combine countryCode + digits
    const digitsOnly = phone.replace(/\D/g, "");
    const fullPhone = `${countryCode}${digitsOnly}`;

    if (!emailRegex.test(email)) {
      alert(t("enter-valid-email"));
      return;
    }
    if (!fullPhone.match(/^\d{13}$/)) {
      alert(t("enter-valid-phone"));
      return;
    }

    setIsLoader(true);
    const user = JSON.parse(
      localStorage.getItem(
        `Parse/${localStorage.getItem("parseAppId")}/currentUser`
      )
    );
    const userId = user?.objectId || "";
    const tenantDetails = await getTenantDetails(userId);
    const tenantId = tenantDetails?.objectId || "";
    if (!tenantId) {
      setIsLoader(false);
      alert(t("something-went-wrong-mssg"));
      return;
    }

    try {
      const baseURL = localStorage.getItem("baseUrl");
      const url = `${baseURL}functions/savecontact`;
      const token = {
        "X-Parse-Session-Token": localStorage.getItem("accesstoken")
      };
      const data = { name, email, phone: fullPhone, tenantId };
      const headers = {
        "Content-Type": "application/json",
        "X-Parse-Application-Id": localStorage.getItem("parseAppId"),
        ...token
      };
      const axiosRes = await axios.post(url, data, { headers });
      const contactRes = axiosRes?.data?.result || {};
      if (contactRes?.objectId) {
        props.details(contactRes);
        if (props.closePopup) {
          props.closePopup();
          setIsLoader(false);
          handleReset();
        }
      }
    } catch (err) {
      console.log("Err", err);
      setIsLoader(false);
      if (err?.response?.data?.error?.includes("already exists")) {
        alert(t("add-signer-alert"));
      } else {
        alert(t("something-went-wrong-mssg"));
      }
    }
  };

  const handleAddYourselfChange = () => {
    if (addYourself) {
      handleReset();
    } else {
      setAddYourself(true);
    }
  };
  const handleReset = () => {
    setAddYourself(false);
    setName("");
    setCountryCode("55");
    setPhone("");
    setEmail("");
  };

  return (
    <div className="h-full px-[20px] py-[10px]">
      {isLoader && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-30">
          <Loader />
        </div>
      )}
      <div className="w-full mx-auto p-[8px]">
        {!props?.isDisableTitle && (
          <div className="text-[14px] font-[700]">{t("add-contact")}</div>
        )}
        {isUserExist && (
          <div className="mb-[0.75rem] flex items-center mt-1">
            <input
              type="checkbox"
              id="addYourself"
              checked={addYourself}
              onChange={handleAddYourselfChange}
              className="op-checkbox op-checkbox-sm"
            />
            <label
              htmlFor="addYourself"
              className="ml-[0.5rem] text-base-content mb-0"
            >
              {t("add-yourself")}
            </label>
          </div>
        )}
        <form className="text-base-content" onSubmit={handleSubmit} noValidate>
          <div className="mb-[0.75rem]">
            <label htmlFor="name" className="text-[13px]">
              {t("name")}
              <span className="text-[13px] text-[red]"> *</span>
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onInvalid={(e) => e.target.setCustomValidity(t("input-required"))}
              onInput={(e) => e.target.setCustomValidity("")}
              required
              disabled={addYourself}
              className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
            />
          </div>
          <div className="mb-[0.75rem]">
            <label htmlFor="email" className="text-[13px]">
              {t("email")}
              <span className="text-[13px] text-[red]"> *</span>
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value?.toLowerCase()?.replace(/\s/g, ""))
              }
              onInvalid={(e) => e.target.setCustomValidity(t("input-required"))}
              onInput={(e) => e.target.setCustomValidity("")}
              required
              disabled={addYourself}
              className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs lowercase"
            />
          </div>
          <div className="mb-[0.75rem]">
            <label htmlFor="phone" className="text-[13px]">
              {t("phone")}
              <span className="text-[13px] text-[red]"> *</span>
            </label>
            <div className="flex gap-2">
              <select
                value={countryCode}
                onChange={e => setCountryCode(e.target.value)}
                required
                className="op-input op-input-bordered op-input-sm w-[200px] text-xs"
                disabled={addYourself}
              >
                {COUNTRY_CODES.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
              <input
                type="text"
                id="phone"
                value={phone}
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, "");
                  if (val.length <= 2) {
                    val = `(${val}`;
                  } else if (val.length <= 7) {
                    val = `(${val.slice(0, 2)}) ${val.slice(2)}`;
                  } else {
                    val = `(${val.slice(0, 2)}) ${val.slice(2, 7)}-${val.slice(7, 11)}`;
                  }
                  setPhone(val);
                }}
                placeholder="(11) 98765-4321"
                required
                maxLength={15}
                pattern="\(\d{2}\)\s\d{5}-\d{4}"
                title="Digite no formato: (XX) XXXXX-XXXX"
                disabled={addYourself}
                className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
              />
            </div>
          </div>

          <div className="mt-6 flex justify-start gap-2">
            <button type="submit" className="op-btn op-btn-primary">
              {t("submit")}
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="op-btn op-btn-secondary"
            >
              {t("reset")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContact;
